// React Imports
import React, { useEffect, useMemo, useRef, useState } from 'react';
// DO NOT REMOVE MapPage import...Not sure why, but it will break the construction of the map page...
import MapPage from './MapPage';
import { Grid, makeStyles, Typography } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';
import HomePageWrapper from '../Common/PageWrappers/HomePageWrapper';
import { fetchUserInsights } from '../../actions/userInsightsActions';
import { useLazyLoadSelector } from '../../util/redux';
import InsightsByClass from '../Dashboard/Widgets/InsightsByClass';
import { fetchDevice } from '../../actions/deviceActions';
import { useDispatch, useSelector } from 'react-redux';
import InsightsVsImages from '../Dashboard/Widgets/InsightsVsImages';
import DashboardToolbar from '../Dashboard/Common/DashboardToolbar';
import { getDisplayName } from '../../util/deviceHelpers';
import HoursSinceLastTable from '../Dashboard/Widgets/HoursSinceLastTable';
import HoursSinceLastGraph from '../Dashboard/Widgets/HoursSinceLastGraph';
import InsightRecievedHourByDay from '../Dashboard/Widgets/InsightRecievedHourByDay';
import { fetchGroups } from '../../actions/groupActions';
import InsightsLast2Weeks from '../Dashboard/Widgets/InsightsLast2Weeks';
import { createTheme } from '@mui/material';
import TotalInsights from '../Dashboard/Widgets/TotalInsights';
import TotalClasses from '../Dashboard/Widgets/TotalClasses';
import InsightStatuses from '../Dashboard/Widgets/InsightStatuses';
import Heatmap from '../Dashboard/Widgets/Heatmap';
import InsightDelay from '../Dashboard/Widgets/InsightDelay';
import TotalDevices from '../Dashboard/Widgets/TotalDevices';
import CommsSource from '../Dashboard/Widgets/CommsSource';
import { FilterManager } from '../../util/filters/filterManager';
import { FILTER_TYPE } from '../../util/filters/filterConstants';
import { GRID_STEPS, WIDGETS } from '../../util/constants';
import { fetchUserWidgets, updateUserWidgets } from '../../actions/dashboardActions';
import CenteredCircularProgress from '../Common/CenteredCircularProgress';

const theme_bp = createTheme({
  breakpoints: {
    values: {
      sm: 625
    },
  },
});


const useStyles = makeStyles({
  widgetContainer: {
    width: "100%",
    position: 'relative'
  },
  scrollContainer: {
    width: "100%",
    overflow: 'auto',
    position: 'relative'
  },
  dashboardContainer: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: 15
  },
});

const insightKey = "insight";

const Dashboard = (props) => {
  const { setTab } = props;

  const classes = useStyles();
  const filterManagerRef = useRef(null);
  if (!filterManagerRef.current) {
    filterManagerRef.current = FilterManager.Builder
      .addFilter(FILTER_TYPE.INSIGHT.CLASS_NAME)
      .addFilter(FILTER_TYPE.INSIGHT.ALL_CLASS_NAMES)
      .addFilter(FILTER_TYPE.DEVICE.NAME)
      .addFilter(FILTER_TYPE.DEVICE.GROUPS)
      .addFilter(FILTER_TYPE.INSIGHT.TIMESTAMP)
      .addFilter(FILTER_TYPE.INSIGHT.FILE_CTIME)
      .setRestrictToScope(true)
      .build()
  }
  const filterManager = filterManagerRef.current;

  const [filteredData, setFilteredData] = useState([]);
  const [processedData, setProcessedData] = useState([]);
  const [groupMap, setGroupMap] = useState({});
  const [formattedWidgets, setFormattedWidgets] = useState([]);
  const [parentHeight, setParentHeight] = useState(0);
  const [parentWidth, setParentWidth] = useState(0);
  const [gridStep, setGridStep] = useState(0);
  const [showArchived, setShowArchived] = useState(false);
  const [edit, setEdit] = useState(false)
  const widgetContainerRef = useRef(null);
  const dispatch = useDispatch();

  const groupData = useLazyLoadSelector((state) => state.group.groupData, fetchGroups, [], false);
  const devices = useLazyLoadSelector((state) => state.device.deviceData, fetchDevice, [], false);
  const insights = useLazyLoadSelector((state) => state.userInsights.userInsightsData, fetchUserInsights, [], false);
  const loadingInsights = useSelector((state) => state.userInsights.userInsightInfoLoading || false);
  const loadingDevices = useSelector((state) => state.device.loadingDevices || false);

  const widgets = useLazyLoadSelector((state) => state.dashboard.widgets, fetchUserWidgets, [], false);
  const loadingWidgets = useSelector((state) => state.dashboard.loadingWidgets || false);

  const isMobile = useMediaQuery({ query: '(max-width: 625px)' });

  const isLoading = () => {
    return !!loadingDevices || !!loadingInsights || !!loadingWidgets;
  }

  const handleWidgetUpdate = async () => {
    await updateUserWidgets(formattedWidgets);
    dispatch(fetchUserWidgets());
  }

  const getComponent = (type) => {
    switch (type) {
      case (WIDGETS.TOTAL_INSIGHTS): return TotalInsights;
      case (WIDGETS.INSIGHT_BY_HOUR_OF_DAY): return InsightRecievedHourByDay;
      case (WIDGETS.DEVICE_HOURS_SINCE_TABLE): return HoursSinceLastTable;
      case (WIDGETS.DEVICE_HOURS_SINCE_GRAPH): return HoursSinceLastGraph;
      case (WIDGETS.TOTAL_CLASSES): return TotalClasses;
      case (WIDGETS.TOTAL_DEVICES): return TotalDevices;
      case (WIDGETS.DEVICE_HEATMAP): return Heatmap;
      case (WIDGETS.INSIGHTS_BY_CLASS): return InsightsByClass;
      case (WIDGETS.INSIGHTS_OVER_2_WEEKS): return InsightsLast2Weeks;
      case (WIDGETS.INSIGHTS_VS_IMAGES): return InsightsVsImages;
      case (WIDGETS.INSIGHT_COMMS_SOURCE): return CommsSource;
      case (WIDGETS.INSIGHT_DELAY): return InsightDelay;
      case (WIDGETS.INSIGHT_STATUSES): return InsightStatuses;
      default: throw new Error("Unknown type")
    }
  }

  const handleSort = (newWidgets) => {
    return [...newWidgets].sort((a, b) => ((b.position.y * GRID_STEPS) + b.position.x) - ((a.position.y * GRID_STEPS) + a.position.x));
  }

  const handleAdd = (option) => {
    const newWidgets = [...formattedWidgets];
    const newWidget = {
      ...option,
      component: getComponent(option.type),
      id: crypto.randomUUID()
    };
    const sortedWidgets = handleSort(newWidgets);
    newWidgets.push(newWidget);
    sortedWidgets.unshift(newWidget);
    handleCollisions(sortedWidgets);
    setFormattedWidgets(newWidgets);
  }

  const handleRemove = (widgetId) => {
    const newWidgets = [...formattedWidgets].filter((widget) => widget.id !== widgetId);
    handleCollisions(handleSort(newWidgets));
    setFormattedWidgets(newWidgets);
  }

  const handleWidgetChange = (widgetMeta) => {
    const newWidgets = [...formattedWidgets];
    for (const widget of newWidgets) {
      if (widget.id === widgetMeta.id) {
        widget.size = widgetMeta.size;
        widget.position = widgetMeta.position;
      }
    }
    handleCollisions(handleSort(newWidgets));
    setFormattedWidgets(newWidgets);
  }

  const handleCollisions = (sortedWidgets) => {
    if (sortedWidgets.length > 0) {
      const stack = sortedWidgets;
      if (isMobile) {
        let position = 0;
        stack.reverse().forEach((widget, index) => {
          widget.position.x = 0;
          widget.position.y = position;
          position += GRID_STEPS;
          widget.size.width = GRID_STEPS;
          widget.size.height = GRID_STEPS;
        });
      } else {
        stack.forEach((widget) => widget.size.width = Math.min(widget.size.width, GRID_STEPS));
        const emptyRow = Array(GRID_STEPS).fill(0);
        const dashboardMap = [];



        stackLoop: while (stack.length > 0) {
          const widget = stack.pop();
          const widgetWidth = widget.size.width;
          const widgetHeight = widget.size.height;
          const widgetX = widget.position.x;
          const widgetY = widget.position.y;

          // increase the dashboard height to support the widget
          if ((widgetY + widgetHeight) >= dashboardMap.length) {
            const dashboardMapHeight = dashboardMap.length;
            for (let i = 0; i <= Math.abs((widgetY + widgetHeight) - dashboardMapHeight); i += 1) {
              dashboardMap.push([...emptyRow]);
            }
          }

          // if widget can't fit in remaining x space
          if ((widgetX + widgetWidth) > GRID_STEPS) {
            widget.position.x = 0;
            widget.position.y = widget.position.y + 1;
            stack.push(widget);
            continue stackLoop;
          }

          // if not all 0s 
          // if can fit in remaining columns, move widget x position
          // if can't fit in remaining columns, move widget x to 0 and mox widget y to next y
          // add back to stack
          for (let xPointer = (widgetX + widgetWidth) - 1; xPointer >= widgetX; xPointer -= 1) {
            for (let yPointer = widgetY; yPointer < (widgetY + widgetHeight); yPointer += 1) {
              if (dashboardMap[yPointer][xPointer] === 1) {
                if ((xPointer + 1 + widgetWidth) > GRID_STEPS) {
                  widget.position.x = 0;
                  widget.position.y = widget.position.y + 1;
                } else {
                  widget.position.x = xPointer + 1;
                }
                stack.push(widget);
                continue stackLoop;
              }
            }
          }

          // if all 0s replace with 1s. Move on to next widget
          for (let xPointer = (widgetX + widgetWidth) - 1; xPointer >= widgetX; xPointer -= 1) {
            for (let yPointer = widgetY; yPointer < (widgetY + widgetHeight); yPointer += 1) {
              dashboardMap[yPointer][xPointer] = 1;
            }
          }
        }
      }
    }
  }

  useEffect(() => {
    if (widgetContainerRef.current) {
      const observer = new ResizeObserver(entries => {
        for (let entry of entries) {
          if (entry.contentRect) {
            setParentWidth(Math.floor(entry.contentRect.width));
          }
        }
      });

      observer.observe(widgetContainerRef.current);

      return () => observer.disconnect();
    }
  }, []);

  useEffect(() => {
    setGridStep(Math.floor(parentWidth / GRID_STEPS))
  }, [parentWidth]);


  useEffect(() => {
    if (widgets && widgets.length > 0) {
        const newWidgets = widgets.map((widget) => {
          return {
            ...widget,
            component: getComponent(widget.type)
          }
        });
        handleCollisions(handleSort(newWidgets));
        setFormattedWidgets(newWidgets);
      }
  }, [widgets]);

  useEffect(() => {
    if (formattedWidgets) {
      setParentHeight(formattedWidgets.reduce((agg, current) => {
        return Math.max(agg, (current.position.y * gridStep) + (current.size.height * gridStep) + (2 * gridStep));
      }, 5 * gridStep));
    }
  }, [formattedWidgets, gridStep])

  useEffect(() => {
    if (devices && groupData) {
      const groupDevice = {};
      for (const group of groupData) {
        for (const device of group.devices) {
          if (!(device in groupDevice)) {
            groupDevice[device] = [];
          }
          groupDevice[device].push(group.group_name);
        }
      }
      setGroupMap(groupDevice);
    }
  }, [devices, groupData]);

  useEffect(() => {
    let data = [];
    if (devices) {
      data = [
        ...data,
        ...devices.map((device, index) => {
          return {
            id: index,
            device,
            data_type: "device",
            device_id: device.device_id,
            device_name: getDisplayName(device),
            location_name: device.location_name,
            location_description: device.location_description,
            last_seen: (new Date(device.last_seen)).toISOString().split(".")[0],
            lat: device.latitude,
            long: device.longitude,
            cycle_time: device.cycle_time,
            trigger_number: device.trigger_number,
            memory_remaining:  device?.summary?.space_remaining || device.memory_remaining || null,
            images_processed: device?.summary?.image_count || device.images_processed || null,
            cycle_count: device?.summary?.cycle_count || null,
            startup_data: device?.summary?.startup_data || 0,
            groups: device.device_id in groupMap ? groupMap[device.device_id] : ["None"],
            hours_since_last_camera_trigger: device?.summary?.hours_since_last_camera_trigger
          }
        })
      ];
    }
    if (insights) {
      data = [
        ...data,
        ...insights.map((insight, index) => {
          return {
            id: index,
            data_type: "insight",
            class_name: insight.class_name.toLowerCase(),
            all_class_names: insight.collection ? insight.class_list.map(cl => cl.className.toLowerCase()) : [],
            alg_id: insight.alg_id,
            insight: insight,
            device_id: insight.device_id,
            device_name: getDisplayName(insight),
            confidence: insight.confidence,
            file_ctime: (new Date(insight.file_ctime)).toISOString().split(".")[0],
            time_stamp: (new Date(insight.time_stamp)).toISOString().split(".")[0],
            comms_source: insight.comms_source,
            lat: insight.latitude,
            long: insight.longitude,
            groups: insight.device_id in groupMap ? groupMap[insight.device_id] : ["None"],
          }
        })
      ];
    }


    setProcessedData(data);
  }, [devices, insights, groupMap]);

  return (
    <HomePageWrapper>
      <div>
        <h1>Dashboard</h1>
      </div>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={12}>
          <DashboardToolbar filterManager={filterManager} data={processedData} setFilteredData={setFilteredData} showArchived={showArchived} setShowArchived={setShowArchived} edit={edit} setEdit={setEdit} addAction={handleAdd} saveAction={handleWidgetUpdate} />
        </Grid>
      </Grid>
      <div className={classes.scrollContainer}>
        <div
          id="widget-container"
          className={classes.widgetContainer}
          ref={widgetContainerRef}
          style={edit ? {
            height: parentHeight,
            backgroundColor: '#fff',
            backgroundImage: `
                  linear-gradient(to right, #ccc 1px, transparent 1px),
                  linear-gradient(to bottom, #ccc 1px, transparent 1px)
                `,
            backgroundSize: `${gridStep}px ${gridStep}px`
          } :
            {
              height: parentHeight
            }
          }
        >
          {
            loadingWidgets ? 
            (<div style={{textAlign: "center", marginTop: "25vh"}}>
              <CenteredCircularProgress size={150} />
            </div>
            )
            : edit || formattedWidgets.length > 0 ? formattedWidgets.map((widget) => {
              const Component = widget.component;
              return (
                <Component gridStep={gridStep} widgetId={widget.id} isLoading={isLoading()} insights={filteredData.filter((d) => d.data_type === insightKey)} devices={filteredData.filter((d) => d.data_type === "device")} allowEdits={edit} handleWidgetChange={handleWidgetChange} position={widget.position} size={widget.size} handleRemove={handleRemove} />
              )
            }) :
            (<Typography variant='h3' style={{textAlign: "center", marginTop: "25vh"}}>Click the Edit Icon to Add Widgets</Typography>)
          }
        </div>
      </div>
    </HomePageWrapper>
  );
};

export default Dashboard;
